// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2024":"3793ec5044ccda62","4289":"3f623d3c6c864f1b","4456":"c92d3b743144863b","4492":"d202a720bcfccba6","5660":"5bd7653ac485632f","7704":"4bdcf9831ed25725","8987":"b3cc3e5c3a0cffcb"}[chunkId] + ".css";
};